import { AxiosCadastro } from "../../service/serviceBasic";
import * as Types from "./types";
import { setMessageConclusaoAction } from "../conclusao/actions";

const setFormulario = (data) => ({
  type: Types.SET_FORMULARIO,
  payload: data,
});

const loadingFormulario = (flag) => ({
  type: Types.LOADING_FORMULARIO,
  payload: flag,
});

export const setDadosAction = (data) => (dispatch) => {
  dispatch(setFormulario(data));
};

export const setRespostaAction = (id, value, indexPergunta, indexAssunto) => (
  dispatch,
  getState
) => {
  const { formularioReducer } = getState();
  const dados = { ...formularioReducer.dados };
  dados.Assuntos[indexAssunto].Perguntas[
    indexPergunta
  ].RespostaEscolhida = dados.Assuntos[indexAssunto].Perguntas[indexPergunta]
    .RespostaEscolhida
    ? dados.Assuntos[indexAssunto].Perguntas[indexPergunta].RespostaEscolhida
    : {};
  dados.Assuntos[indexAssunto].Perguntas[indexPergunta].RespostaEscolhida[
    id
  ] = value;

  dispatch(setFormulario(dados));
};

export const getDadosFormularioAction = (id, history) => (dispatch) => {
  dispatch(loadingFormulario(true));

  return AxiosCadastro.post("v1/formulario/formulario/getByUser", {
    IdPessoa: id,
  })
    .then((response) => {
      dispatch(setFormulario(response.data));
    })
    .catch((error) => {
      dispatch(
        setMessageConclusaoAction({
          icon: "fa-close",
          title: "Não foi possível efetuar a exibição do formulário!",
          error: error,
          discription: `Algo deu errado ao tentar receber o formulário, é possível que alguma informação preenchida esteja inconsistente.`,
          isError: true,
        })
      );
      history.push("/");
    })
    .finally(() => {
      dispatch(loadingFormulario(false));
    });
};

export const setDadosFormularioAction = (history) => (dispatch, getState) => {
  dispatch(loadingFormulario(true));
  const { formularioReducer } = getState();
  const dados = { ...formularioReducer.dados };

  return AxiosCadastro.post("v1/formulario/formulario/post", dados)
    .then(() => {
      history.push("/kyc/sucesso");
    })
    .catch((error) => {
      dispatch(
        setMessageConclusaoAction({
          icon: "fa-close",
          title: "Não foi possível efetuar o envio do formulário!",
          error: error,
          discription: `Algo deu errado ao tentar enviar o formulário, é possível que alguma informação preenchida esteja inconsistente.`,
          isError: true,
        })
      );
    })
    .finally(() => {
      dispatch(loadingFormulario(false));
    });
};
